import {TooltipProps, Tooltip, tooltipClasses, styled} from '@mui/material';

export const StyledTooltip = styled(({className, ...props}: TooltipProps) => (
  <Tooltip {...props} classes={{popper: className}} />
))(({theme}) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.grey[700],
    boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.25)',
    minWidth: '100px',
    textAlign: 'left',
  },
}));
